import React, { PureComponent } from 'react';

import { debounce } from '../../utils';

import IconSearch from '../../icons/icon-search';

export default class SearchField extends PureComponent {
    constructor(props) {
        super(props);

        this.inputFieldElement = null;

        this.state = {
            focus: false,
            value: this.props.value || ''
        };

        this.debouncedChange = debounce(this.props.onChange, props.debounce, this);
    }

    handleChange = () => {
        const value = this.inputFieldElement.value;

        this.setValue(value);
    }

    handleFocus = () => {
        this.setState({
            focus: true
        });

        this.props.onFocus && this.props.onFocus()
    }

    handleBlur = () => {
        this.setState({
            focus: false
        });

        this.props.onBlur && this.props.onBlur()
    }

    handleClearClick = () => {
        this.setValue('');
    }

    setValue(value) {
        if (this.props.onChange && this.props.debounce) {
            this.debouncedChange(value);
        } else {
            this.props.onChange(value);
        }

        this.setState({ value });
    }

    get populated() {
        return this.state.value !== '';
    }

    get expanded() {
        return this.props.expanded || this.state.focus || this.populated;
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            focus: () => {
                this.inputFieldElement && this.inputFieldElement.focus();
            },
            blur: () => {
                this.inputFieldElement && this.inputFieldElement.blur();
            },
            getValue: () => this.state.value
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value && this.props.value !== this.state.value) {
            this.setState({
                value: this.props.value
            });
        }
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        return (
            <div className={'search-field ' + (this.props.className || '') + (this.state.focus ? ' focus' : '') + (this.populated ? ' populated' : '') + (this.expanded ? ' expanded' : '') + (this.props.full ? ' full' : '')}>
                <span className="field-icon">
                    <IconSearch />
                </span>

                <input
                    type="search"
                    className="field-input"
                    ref={(element) => {this.inputFieldElement = element}}
                    placeholder={this.props.placeholder}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    value={this.state.value}
                    onBlur={this.handleBlur}
                />

                <span className="field-clear" onClick={this.handleClearClick}>
                    <i className="ion ion-close-round" />
                </span>
            </div>
        );
    }
}
